import {useInfiniteQuery, useQuery} from 'react-query';

import {searchThroughAll, searchThroughInputs} from '.';

export const useSearchThroughAll = (searchText: ISearchThroghAllParams) => {
  const {data, isLoading, hasNextPage, fetchNextPage} = useInfiniteQuery({
    queryKey: ['get-search-through-all', searchText],

    queryFn: ({pageParam = 1}) => searchThroughAll(pageParam, searchText),
    getNextPageParam: (_, allPages) => {
      return allPages[allPages.length - 1]?.next
        ? new URL(allPages[allPages.length - 1]?.next || '').searchParams.get(
            'page',
          )
        : undefined;
    },
    enabled: !!searchText.search && searchText.search.trim().length > 0,
  });

  return {data, isLoading, hasNextPage, fetchNextPage};
};

export const useSearchThroughInput = (payload: ISearchThroughInputParams) => {
  const {data, isLoading} = useQuery(
    ['get-search-through-input', payload],
    () => searchThroughInputs(payload),
    {
      enabled: !!payload.title && payload.title.trim().length > 0,
    },
  );

  return {data, isLoading};
};
